import { Col, Row, Typography, Card, Button, Space, message } from 'antd';
import React from 'react';
import StyledContainer from '../StyledContainer';
import { SpotifyOutlined, CopyOutlined } from '@ant-design/icons'; // Iconos de Antd

const { Title, Paragraph, Text } = Typography;

const BlogPost = ({ BlogPostData, Language }) => {
  const [messageApi, contextHolder] = message.useMessage(); // Manejador de alertas de Antd

  const getSpotifyEmbedUrl = (url) => {
    if (!url) return null;
    try {
      const cleanUrl = url.trim();
      if (cleanUrl.includes('/embed/')) return cleanUrl;
      if (cleanUrl.includes('://spotify.com')) {
        return cleanUrl.replace('://spotify.com', '://spotify.comembed/');
      }
      return cleanUrl;
    } catch (error) {
      return null;
    }
  };

  const spotifyLink = BlogPostData.podcast?.[Language];
  const embedUrl = getSpotifyEmbedUrl(spotifyLink);

  const handleCopyLink = () => {
    if (!spotifyLink) return;
    navigator.clipboard.writeText(spotifyLink)
      .then(() => {
        messageApi.open({
          type: 'success',
          content: Language === 'ES' ? '¡Enlace copiado al portapapeles!' : 'Link copied to clipboard!',
        });
      })
      .catch(() => {
        messageApi.open({
          type: 'error',
          content: Language === 'ES' ? 'No se pudo copiar el enlace' : 'Failed to copy link',
        });
      });
  };

  return (
    <div style={{ background: '#fafafa', paddingBottom: '5rem' }}>
      {contextHolder}

      <StyledContainer>
        <Row justify="center">
          <Col xs={24} sm={22} md={18} lg={20} xl={20}>

            {BlogPostData.banner && (
              <img
                src={BlogPostData.banner}
                alt="banner-post"
                loading="lazy"
                style={{ width: '800px', maxHeight: '400px', objectFit: 'cover', borderRadius: '12px', marginBottom: '2rem' }}
              />
            )}

            <Card variant="borderless" style={{ borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.03)' }}>
              <Title level={1} style={{ fontSize: '2.5rem', marginBottom: '0.5rem', lineHeight: '1.3' }}>
                {BlogPostData.title[Language]}
              </Title>

              <div style={{ marginBottom: '1.5rem', color: '#8c8c8c', fontSize: '14px' }}>
                {BlogPostData.postedDate && (
                  <span>
                    {Language === 'ES' ? 'Publicado el ' : 'Posted on '}
                    {new Date(BlogPostData.postedDate).toLocaleDateString(Language === 'ES' ? 'es-ES' : 'en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                  </span>
                )}
                {BlogPostData.postedDate && BlogPostData.updatedDate && (
                  <span> · </span>
                )}
                {BlogPostData.updatedDate && (
                  <span>
                    {Language === 'ES' ? 'Actualizado el ' : 'Updated on '}
                    {new Date(BlogPostData.updatedDate).toLocaleDateString(Language === 'ES' ? 'es-ES' : 'en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                  </span>
                )}
              </div>

              {spotifyLink && (
                <div style={{ marginBottom: '2.5rem' }}>
                  {embedUrl && (
                    <div style={{ borderRadius: '12px', overflow: 'hidden', background: '#000' }}>
                      <iframe
                        title="Spotify Podcast Player"
                        data-testid="embed-iframe"
                        style={{ borderRadius: "12px" }}
                        src={embedUrl}
                        width="100%"
                        height="152"
                        frameBorder="0"
                        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                        loading="lazy">
                      </iframe>
                    </div>
                  )}

                  <div style={{ marginTop: '0.75rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
                    <Text type="secondary" style={{ fontSize: '14px' }}>
                      {Language === 'ES' ? '¿No puedes ver el reproductor?' : "Can't see the player?"}
                    </Text>

                    <Space size="middle">
                      <Button
                        type="link"
                        icon={<SpotifyOutlined style={{ color: '#1DB954' }} />}
                        href={spotifyLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ padding: 0, height: 'auto', display: 'flex', alignItems: 'center' }}
                      >
                        {Language === 'ES' ? 'Escuchar en Spotify' : 'Listen on Spotify'}
                      </Button>

                      <Button
                        type="dashed"
                        size="small"
                        icon={<CopyOutlined />}
                        onClick={handleCopyLink}
                        style={{ borderRadius: '6px' }}
                      >
                        {Language === 'ES' ? 'Copiar link' : 'Copy link'}
                      </Button>
                    </Space>
                  </div>
                </div>
              )}

              <Typography>
                <Paragraph style={{ fontSize: '18px', lineHeight: '1.8', color: '#262626', textAlign: 'justify' }}>
                  {BlogPostData.content[Language]}
                </Paragraph>
              </Typography>
            </Card>

          </Col>
        </Row>
      </StyledContainer>
    </div>
  );
};

export default BlogPost;
